import {Alert} from "@mantine/core";
import {modals} from "@mantine/modals";
import { EyeIcon } from "@phosphor-icons/react";
import {Row} from "../../../components/Flex/Flex";
import CGT from "../../../utils/CGT.ts";

export default function LastSighting ({sighting, onRemove}) {
    const date = CGT.fromSeconds(sighting.date);

    const confirmRemove = () => {
        modals.openConfirmModal({
            title: 'Remove sighting',
            children: <p>Are you sure you want to remove this sighting from the contract?</p>,
            labels: {confirm: 'Remove', cancel: 'Cancel'},
            confirmProps: {color: 'red'},
            onConfirm: onRemove,
        });
    };

    return (
        <Row justify="center" className="mt-2">
            <Alert color="yellow" icon={<EyeIcon size={16}/>} withCloseButton closeButtonLabel="Remove sighting" onClose={confirmRemove}>{`Target last spotted at ${sighting.location.system.name} (${sighting.location.system.galX}, ${sighting.location.system.galY}) on ${date.toCGT(true)} by ${sighting.spotter}`}</Alert>
        </Row>

    )
}
